import { TReduxActions } from '../../actions';
import { EFetchMapDataActionType } from '../../actions/fetchMapData/types';
import { ELoadListingActionTypes } from '../../actions/listingOffers';
import { IAnalyticsState } from '../../types/analytics';

const defaultState: IAnalyticsState = {
  mlSearchSessionGuid: null,
};

export function analyticsReducer(state: IAnalyticsState = defaultState, action: TReduxActions): IAnalyticsState {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed:
    case ELoadListingActionTypes.Success: {
      const { mlSearchSessionGuid } = action.payload;

      if (mlSearchSessionGuid == null) {
        return state;
      }

      return { ...state, mlSearchSessionGuid };
    }

    default:
      return state;
  }
}
